import { ManagementGender } from '@/api/lms/managementUsers'

export function getManagementGender(gender: string): ManagementGender {
  return (
    Object.values(ManagementGender).find((mg) => {
      return mg === gender
    }) || ManagementGender.OTHER
  )
}
